export const getErrorMessage = (error: any): string => error.response?.data?.message || error.message;
